import qs from "qs";

import marriottMappings from "./marriottMappings.json";
import { MARRIOTT_AVAILABILITY_URL } from "./types";

function formatDateToMarriott(
  inputDate: string,
  language: string,
  addOneDay = false,
) {
  if (inputDate) {
    const [year, month, day] = inputDate.split("-").map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));

    if (addOneDay) {
      date.setUTCDate(date.getUTCDate() + 1);
    }

    return date.toLocaleDateString(language ?? "en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      timeZone: "UTC",
    });
  }
  // fr, es, en-gb, it: day/month/year
  // english: month/day/year
  return null;
}

export function getMarriottAvailabilityRedirectURL(
  checkIn: string,
  checkOut: string,
  collectionId: string,
  locale: string,
  sleeps: number,
) {
  const marshaCode =
    marriottMappings.listings[collectionId]?.marriottPropertyCode;
  const checkInDate = checkIn ?? new Date().toISOString().split("T")[0];

  const fromDate = formatDateToMarriott(checkInDate, locale);
  const toDate =
    checkInDate && !checkOut
      ? formatDateToMarriott(checkInDate, locale, true)
      : formatDateToMarriott(checkOut, locale);

  const baseParams = {
    fromDate,
    toDate,
    roomCount: 1,
    numAdultsPerRoom: sleeps,
    showMore: false,
    marriottBrands: "SN",
    iscid: "sonder_search_referral",
  };

  if (marshaCode) {
    const marshaParams = qs.stringify({
      ...baseParams,
      propertyCode: marshaCode,
      isSearch: true,
      showFullPrice: false,
    });

    return `${MARRIOTT_AVAILABILITY_URL}/${marshaParams}`;
  }
  return null;
}
